// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

export const getData = createAsyncThunk('sellers/getData', async params => {

    let dataUsers = [
        {
            id: 1,
            billing: 'Manual - Credit Card',
            full_name: 'Galen Slixby',
            company: 'Yotz PVT LTD',
            role: 'editor',
            username: 'gslixby0',
            country: 'El Salvador',
            contact: '33 1234 5678',
            email: 'gslixby0@abc.net.au',
            currentPlan: 'enterprise',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/1.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            name: "Miguel Angel",
            lastName: "Lopéz",
            motherLastName: "García",
            gender: "Masculino",
            educationLevel: "Nivel Superior",
            profession: "Estudiandte",
            rfc: "VECJ880326",
            maritalStatus: "Soltero",
            address: {
                street: "Juan Palomar y Arias",
                outdoorNumber: 70,
                interiorNumber: 401,
                colony: "Vallarta Norte",
                postalCode: 45053,
                municipality: "Zapopan",
                city: "Zapopan",
                state: "Jalisco"
            },
            knowPerfectShopper: "rrss",
            antiquity: "2 años",
            invite: "yes",
            whoInvite: "Veronica Perez"
        },
        {
            id: 2,
            billing: 'Manual - Paypal',
            full_name: 'Halsey Redmore',
            company: 'Skinder PVT LTD',
            role: 'author',
            username: 'hredmore1',
            country: 'Albania',
            contact: '33 1234 5678',
            email: 'hredmore1@imgur.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/10.png'),
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: false,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 3,
            billing: 'Auto Debit',
            full_name: 'Marjory Sicely',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'msicely2',
            country: 'Russia',
            contact: '33 1234 5678',
            email: 'msicely2@who.int',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/1.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 4,
            billing: 'Manual - Credit Card',
            full_name: 'Cyrill Risby',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'crisby3',
            country: 'China',
            contact: '33 1234 5678',
            email: 'crisby3@wordpress.com',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "6 meses"
        },
        {
            id: 5,
            billing: 'Auto Debit',
            full_name: 'Maggy Hurran',
            company: 'Aimbo PVT LTD',
            role: 'subscriber',
            username: 'mhurran4',
            country: 'Pakistan',
            contact: '33 1234 5678',
            email: 'mhurran4@yahoo.co.jp',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/10.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 6,
            billing: 'Auto Debit',
            full_name: 'Silvain Halstead',
            company: 'Jaxbean PVT LTD',
            role: 'author',
            username: 'shalstead5',
            country: 'China',
            contact: '33 1234 5678',
            email: 'shalstead5@shinystat.com',
            currentPlan: 'company',
            status: 'active',
            avatar: '',
            avatarColor: 'light-success',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 7,
            billing: 'Manual - Paypal',
            full_name: 'Breena Gallemore',
            company: 'Jazzy PVT LTD',
            role: 'subscriber',
            username: 'bgallemore6',
            country: 'Canada',
            contact: '33 1234 5678',
            email: 'bgallemore6@boston.com',
            currentPlan: 'company',
            status: 'active',
            avatar: '',
            avatarColor: 'light-danger',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 8,
            billing: 'Manual - Cash',
            full_name: 'Kathryne Liger',
            company: 'Pixoboo PVT LTD',
            role: 'author',
            username: 'kliger7',
            country: 'France',
            contact: '33 1234 5678',
            email: 'kliger7@vinaora.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 9,
            billing: 'Auto Debit',
            full_name: 'Franz Scotfurth',
            company: 'Tekfly PVT LTD',
            role: 'subscriber',
            username: 'fscotfurth8',
            country: 'China',
            contact: '33 1234 5678',
            email: 'fscotfurth8@dailymotion.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/2.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 10,
            billing: 'Auto Debit',
            full_name: 'Jillene Bellany',
            company: 'Gigashots PVT LTD',
            role: 'maintainer',
            username: 'jbellany9',
            country: 'Jamaica',
            contact: '33 1234 5678',
            email: 'jbellany9@kickstarter.com',
            currentPlan: 'company',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 11,
            billing: 'Manual - Paypal',
            full_name: 'Jonah Wharlton',
            company: 'Eare PVT LTD',
            role: 'subscriber',
            username: 'jwharltona',
            country: 'United States',
            contact: '33 1234 5678',
            email: 'jwharltona@oakley.com',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/4.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 12,
            billing: 'Manual - Credit Card',
            full_name: 'Seth Hallam',
            company: 'Yakitri PVT LTD',
            role: 'subscriber',
            username: 'shallamb',
            country: 'Peru',
            contact: '33 1234 5678',
            email: 'shallamb@hugedomains.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/5.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 13,
            billing: 'Auto Debit',
            full_name: 'Yoko Pottie',
            company: 'Leenti PVT LTD',
            role: 'subscriber',
            username: 'ypottiec',
            country: 'Philippines',
            contact: '33 1234 5678',
            email: 'ypottiec@privacy.gov.au',
            currentPlan: 'basic',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/7.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 14,
            billing: 'Auto Debit',
            full_name: 'Maximilianus Krause',
            company: 'Digitube PVT LTD',
            role: 'author',
            username: 'mkraused',
            country: 'Democratic Republic of the Congo',
            contact: '33 1234 5678',
            email: 'mkraused@stanford.edu',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/9.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 15,
            billing: 'Auto Debit',
            full_name: 'Zsazsa McCleverty',
            company: 'Kaymbo PVT LTD',
            role: 'maintainer',
            username: 'zmcclevertye',
            country: 'France',
            contact: '33 1234 5678',
            email: 'zmcclevertye@soundcloud.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: require('@src/assets/images/avatars/2.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 16,
            billing: 'Auto Debit',
            full_name: 'Bentlee Emblin',
            company: 'Yambee PVT LTD',
            role: 'author',
            username: 'bemblinf',
            country: 'Spain',
            contact: '33 1234 5678',
            email: 'bemblinf@wired.com',
            currentPlan: 'company',
            status: 'active',
            avatar: require('@src/assets/images/avatars/6.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 17,
            billing: 'Manual - Paypal',
            full_name: 'Brockie Myles',
            company: 'Wikivu PVT LTD',
            role: 'maintainer',
            username: 'bmylesg',
            country: 'Poland',
            contact: '33 1234 5678',
            email: 'bmylesg@amazon.com',
            currentPlan: 'basic',
            status: 'active',
            avatar: '',
            avatarColor: 'light-warning',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 18,
            billing: 'Manual - Cash',
            full_name: 'Bertha Biner',
            company: 'Twinte PVT LTD',
            role: 'editor',
            username: 'bbinerh',
            country: 'Yemen',
            contact: '33 1234 5678',
            email: 'bbinerh@mozilla.com',
            currentPlan: 'team',
            status: 'active',
            avatar: require('@src/assets/images/avatars/7.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 19,
            billing: 'Manual - Cash',
            full_name: 'Travus Bruntjen',
            company: 'Cogidoo PVT LTD',
            role: 'admin',
            username: 'tbruntjeni',
            country: 'France',
            contact: '33 1234 5678',
            email: 'tbruntjeni@sitemeter.com',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: '',
            avatarColor: 'light-info',
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        },
        {
            id: 20,
            billing: 'Auto Debit',
            full_name: 'Wesley Burland',
            company: 'Bubblemix PVT LTD',
            role: 'editor',
            username: 'wburlandj',
            country: 'Honduras',
            contact: '33 1234 5678',
            email: 'wburlandj@uiuc.edu',
            currentPlan: 'team',
            status: 'inactive',
            avatar: require('@src/assets/images/avatars/6.png').default,
            createdAt: "11/Sep/2022",
            credit: 10000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            antiquity: "8 años"
        }

    ]
    return {
        params,
        data: dataUsers,
        total: dataUsers.length
    }
})

export const addSeller = createAsyncThunk('sellers/addSeller', async (promoter, { dispatch, getState }) => {
    let result = await axios.post('/apps/sellers/add-promoter', promoter)
    // await dispatch(getData(getState().sellers.params))
    // let result = true
    return result
})

export const updateSeller = createAsyncThunk('sellers/updateSeller', async (promoter, { dispatch, getState }) => {
    let result = await axios.post('/apps/sellers/update-seller', promoter)
    // await dispatch(getData(getState().sellers.params))
    // let result = false
    return result
})

export const deleteSeller = createAsyncThunk('sellers/deleteSeller', async (id, { dispatch, getState }) => {
    await axios.delete('/apps/sellers/delete', { id })
    await dispatch(getData(getState().sellers.params))
    return id
})

export const getTotalSellers = createAsyncThunk('sellers/getTotalSellers', async () => {
    // const response = await axios.get('/api/sellers/getTotalSellers')
    const responseDummy = {
        data: {
            totalSellers: 1200,
            activeSellers: 980,
            inactiveSellers: 400
        }
    }
    return responseDummy.data
})

export const getSeller = createAsyncThunk('sellers/getSeller', async (id, { dispatch, getState }) => {
    // const response = await axios.get('/api/sellers/promote', { id })
    // return response.data.seller
    const seller = {
        data: {
            id: 1,
            billing: 'Manual - Credit Card',
            full_name: 'Galen Slixby',
            company: 'Yotz PVT LTD',
            role: 'editor',
            username: 'gslixby0',
            country: 'El Salvador',
            contact: '33 1234 5678',
            email: 'gslixby0@abc.net.au',
            currentPlan: 'enterprise',
            status: 'active',
            avatar: "",
            createdAt: "11/Sep/2022",
            credit: 10000,
            creditUsed: 7000,
            statusCredit: true,
            discount: 10,
            promoterCode: 44331,
            gender: "Femenino",
            maritalStatus: "Soltero",
            educationLevel: "Nivel Superior",
            profession: "Estudiandte",
            rfc: "VECJ880326",
            address: {
                street: "Juan Palomar y Arias",
                outdoorNumber: 70,
                interiorNumber: 401,
                colony: "Vallarta Norte",
                postalCode: 45053,
                municipality: "Zapopan",
                city: "Zapopan",
                state: "Jalisco"
            },
            sales: [
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new",
                    hour: "11:30 am"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000.50,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "pending",
                    hour: "11:30 am"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new",
                    hour: "11:30 am"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "new"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "paid"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    percentagePromotor: {
                        total: 100,
                        discount: 10
                    },
                    percentageSeller: {
                        total: 100,
                        discount: 10
                    },
                    date: "04/Sep/2022",
                    status: "paid"
                },
                {
                    order: 12234,
                    seller: "Ricardo Gómes Robles",
                    pairs: 2,
                    total: 1000,
                    discount: 200,
                    totalPay: 800,
                    date: "04/Sep/2022",
                    status: "new"
                }
            ]
        }
    }
    return seller.data

})

export const sellersSlice = createSlice({
    name: 'sellers',
    initialState: {
        data: [],
        total: 1,
        params: {},
        totalSellersData: {
            totalSellers: 0,
            activeSellers: 0,
            inactiveSellers: 0
        },
        selectedUser: null,
        detailOrder: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.params = action.payload.params
                state.total = action.payload.total
            })
            .addCase(getTotalSellers.fulfilled, (state, action) => {
                state.totalSellersData.totalSellers = action.payload.totalSellers
                state.totalSellersData.activeSellers = action.payload.activeSellers
                state.totalSellersData.inactiveSellers = action.payload.inactiveSellers
            })
            .addCase(getSeller.fulfilled, (state, action) => {
                state.selectedUser = action.payload
            })
    }
})

export default sellersSlice.reducer
